<template>
  <g class="zonen" style="opacity: 1">
    <path
      v-model="active.d"
      class="fill-current"
      :class="bg(active.d)"
      d="M699,301h259.8C908.4,184.9,815.1,91.6,699,41.2V301z"
    /><path
      v-model="active.di"
      class="fill-current"
      :class="bg(active.di)"
      d="M1000,495c-0.6-65.1-13.7-127.1-36.9-184H796v184H1000z"
    /><rect
      v-model="active.dis"
      class="fill-current"
      :class="bg(active.dis)"
      x="699"
      y="408"
      width="87"
      height="87"
    /><rect
      v-model="active.dic"
      class="fill-current"
      :class="bg(active.dic)"
      x="699"
      y="311"
      width="87"
      height="87"
    /><path
      v-model="active.ds"
      class="fill-current"
      :class="bg(active.ds)"
      d="M689,398v-87H602v49h-0.1l-91.1,91.2c18.9,4.2,33.8,19.1,38,38L640,398L689,398z"
    /><polygon
      v-model="active.dsi"
      class="fill-current"
      :class="bg(active.dsi)"
      points="689,495 689,408 644.2,408 557.2,495 "
    /><polygon
      v-model="active.dsc"
      class="fill-current"
      :class="bg(active.dsc)"
      points="505,442.9 592,355.9 592,311 505,311 "
    /><path
      v-model="active.dc"
      class="fill-current"
      :class="bg(active.dc)"
      d="M505,0v204h184V36.9C632.1,13.7,570.1,0.6,505,0"
    /><rect
      v-model="active.dci"
      class="fill-current"
      :class="bg(active.dci)"
      x="602"
      y="214"
      width="87"
      height="87"
    /><rect
      v-model="active.dcs"
      class="fill-current"
      :class="bg(active.dcs)"
      x="505"
      y="214"
      width="87"
      height="87"
    /><path
      v-model="active.i"
      class="fill-current"
      :class="bg(active.i)"
      d="M958.8,699H699v259.8C815.1,908.4,908.4,815.1,958.8,699"
    /><path
      v-model="active.id"
      class="fill-current"
      :class="bg(active.id)"
      d="M1000,505H796v184h167.1C986.3,632.1,999.4,570.1,1000,505"
    /><rect
      v-model="active.ids"
      class="fill-current"
      :class="bg(active.ids)"
      x="699"
      y="602"
      width="87"
      height="87"
    /><rect
      v-model="active.idc"
      class="fill-current"
      :class="bg(active.idc)"
      x="699"
      y="505"
      width="87"
      height="87"
    /><path
      v-model="active.is"
      class="fill-current"
      :class="bg(active.is)"
      d="M505,1000V796h184v167.1C632.1,986.3,570.1,999.4,505,1000"
    /><rect
      v-model="active.isd"
      class="fill-current"
      :class="bg(active.isd)"
      x="602"
      y="699"
      width="87"
      height="87"
    /><rect
      v-model="active.isc"
      class="fill-current"
      :class="bg(active.isc)"
      x="505"
      y="699"
      width="87"
      height="87"
    /><path
      v-model="active.ic"
      class="fill-current"
      :class="bg(active.ic)"
      d="M602,689h87v-87.1h-49v-0.1l-91.2-91.1c-4.2,18.9-19.1,33.8-38,38L602,640L602,689z"
    /><polygon
      v-model="active.icd"
      class="fill-current"
      :class="bg(active.icd)"
      points="557.1,505 644.1,591.9 689,591.9 689,505 "
    /><polygon
      v-model="active.ics"
      class="fill-current"
      :class="bg(active.ics)"
      points="505,689 592,689 592,644.1 505,557.1 "
    /><path
      v-model="active.s"
      class="fill-current"
      :class="bg(active.s)"
      d="M41.2,699H301v259.8C184.9,908.4,91.6,815.1,41.2,699"
    /><path
      v-model="active.sd"
      class="fill-current"
      :class="bg(active.sd)"
      d="M311,602v87h87.1v-49h0.1l91.1-91.2c-18.9-4.2-33.8-19.1-38-38L360,602L311,602z"
    /><polygon
      v-model="active.sdi"
      class="fill-current"
      :class="bg(active.sdi)"
      points="495,557.1 408.1,644.1 408.1,689 495,689 "
    /><polygon
      v-model="active.sdc"
      class="fill-current"
      :class="bg(active.sdc)"
      points="311,505 311,592 355.9,592 442.9,505 "
    /><path
      v-model="active.si"
      class="fill-current"
      :class="bg(active.si)"
      d="M495,1000c-65.1-0.6-127.1-13.7-184-36.9V796h184V1000z"
    /><rect
      v-model="active.sid"
      class="fill-current"
      :class="bg(active.sid)"
      x="408"
      y="699"
      width="87"
      height="87"
    /><rect
      v-model="active.sic"
      class="fill-current"
      :class="bg(active.sic)"
      x="311"
      y="699"
      width="87"
      height="87"
    /><path
      v-model="active.sc"
      class="fill-current"
      :class="bg(active.sc)"
      d="M0,505h204v184H36.9C13.7,632.1,0.6,570.1,0,505"
    /><rect
      v-model="active.scd"
      class="fill-current"
      :class="bg(active.scd)"
      x="214"
      y="505"
      width="87"
      height="87"
    /><rect
      v-model="active.sci"
      class="fill-current"
      :class="bg(active.sci)"
      x="214"
      y="602"
      width="87"
      height="87"
    /><path
      v-model="active.c"
      class="fill-current"
      :class="bg(active.c)"
      d="M301,301H41.2C91.6,184.9,184.9,91.6,301,41.2V301z"
    /><path
      v-model="active.cd"
      class="fill-current"
      :class="bg(active.cd)"
      d="M495,0c-65.1,0.6-127.1,13.7-184,36.9V204h184V0z"
    /><rect
      v-model="active.cdi"
      class="fill-current"
      :class="bg(active.cdi)"
      x="408"
      y="214"
      width="87"
      height="87"
    /><rect
      v-model="active.cds"
      class="fill-current"
      :class="bg(active.cds)"
      x="311"
      y="214"
      width="87"
      height="87"
    /><path
      v-model="active.ci"
      class="fill-current"
      :class="bg(active.ci)"
      d="M398,311h-87v87.1h49v0.1l91.2,91.1c4.2-18.9,19.1-33.8,38-38L398,360L398,311z"
    /><polygon
      v-model="active.cid"
      class="fill-current"
      :class="bg(active.cid)"
      points="495,311 408,311 408,355.9 495,442.9 "
    /><polygon
      v-model="active.cis"
      class="fill-current"
      :class="bg(active.cis)"
      points="442.9,495 355.9,408.1 311,408.1 311,495 "
    /><path
      v-model="active.cs"
      class="fill-current"
      :class="bg(active.cs)"
      d="M0,495c0.6-65.1,13.7-127.1,36.9-184H204v184H0z"
    /><rect
      v-model="active.csd"
      class="fill-current"
      :class="bg(active.csd)"
      x="214"
      y="311"
      width="87"
      height="87"
    /><rect
      v-model="active.csi"
      class="fill-current"
      :class="bg(active.csi)"
      x="214"
      y="408"
      width="87"
      height="87"
    />
  </g>
</template>

<script>
export default {
  props: {
    activeZones: {
      type: Object,
      required: false,
      default: function () {
        return {
          d: 0,
          di: 0,
          dis: 0,
          dic: 0,
          ds: 0,
          dsi: 0,
          dsc: 0,
          dc: 0,
          dci: 0,
          dcs: 0,
          i: 0,
          id: 0,
          ids: 0,
          idc: 0,
          is: 0,
          isd: 0,
          isc: 0,
          ic: 0,
          icd: 0,
          ics: 0,
          s: 0,
          sd: 0,
          sdi: 0,
          sdc: 0,
          si: 0,
          sid: 0,
          sic: 0,
          sc: 0,
          scd: 0,
          sci: 0,
          c: 0,
          cd: 0,
          cdi: 0,
          cds: 0,
          ci: 0,
          cid: 0,
          cis: 0,
          cs: 0,
          csd: 0,
          csi: 0,
        };
      },
    },
  },

  data() {
    return {
      active: this.activeZones,
    };
  },

  watch: {
    activeZones: function (newVal, oldVal) {
      this.active = newVal;
    },
  },

  methods: {
    bg(state) {
      if (state == 1) {
        return 'text-white opacity-30';
      }

      if (state == 2) {
        return 'text-white opacity-100';
      }

      if (state == 3) {
        return 'text-markencode-red';
      }

      return 'text-white opacity-0';
    },
  },
};
</script>